module.exports = __webpack_public_path__ + "static/Burst_5s-06d21c2c446cea18cc9639ec21dd1446.jpg";